/** Per-kind config for bond-retrieval detailed information (Phase 9.13D). */

export const BLANKET_BOND_TERM_OPTIONS = [
  { value: "1 Year Bond", price: "$175.00" },
  { value: "2 Year Bond", price: "$306.00" },
  { value: "3 Year Bond", price: "$437.00" },
];

export const RETRIEVAL_DETAILED_INFO_CONFIG = {
  blanket: {
    kind: "blanket",
    title: "Detailed Information",
    documentsHeading: "Documents",
    showBondTerm: true,
    bondTermOptions: BLANKET_BOND_TERM_OPTIONS,
    documentRows: [
      { label: "Bond Application", fileNameField: "bondAppFileName", fileLinkField: "bondAppLink" },
      { label: "Bond Document", fileNameField: "bondFileName", fileLinkField: "bondLink" },
      { label: "Indemnity Agreement", fileNameField: "indemnityFileName", fileLinkField: "indemnityLink" },
      { label: "Cancellation Document", fileNameField: "cancellationDocument", fileLinkField: "cancellationDocumentLink" },
      {
        label: "Credit Report Document",
        fileNameField: "creditDocument",
        fileLinkField: "creditDocumentLink",
        requiresCreditReportAccess: true,
      },
      { label: "FCRA Document", fileNameField: "fcraDocument", fileLinkField: "fcraDocumentLink" },
      {
        label: "Verification Certificate",
        fileNameField: "verificationCertDocument",
        fileLinkField: "verificationCertDocumentLink",
      },
      {
        label: "Power of Attorney",
        fileNameField: "verificationPoaDocument",
        fileLinkField: "verificationPoaDocumentLink",
      },
    ],
  },
};

export function getRetrievalDetailedInfoConfig(kind) {
  return RETRIEVAL_DETAILED_INFO_CONFIG[kind] || RETRIEVAL_DETAILED_INFO_CONFIG.blanket;
}
